import axios from 'axios';
import {backendHost} from '../../config';

export const getInvite = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/invite`, {params});
};